import { ApiBase } from "./ApiBase";
import { IPaymentStatusResponse } from "../../DTO/Response/IPaymentStatusResponse";
import { IApiResponse } from "../../DTO/Response/IApiResponse";

export class PaymentStatusApi extends ApiBase {
    public async GetPaymentStatus(
        uniqueReference: string
    ): Promise<IApiResponse<IPaymentStatusResponse>> {
        const urlEncodedUniqueReference = encodeURIComponent(uniqueReference);
        const appSettings = await (await fetch("/config.json")).json();

        let landingPageUrl = `${appSettings.ApimanagementURL}/paymentscallback/v2/landingpage/${urlEncodedUniqueReference}/status`;

        if (process.env.NODE_ENV.toLowerCase() === "development") {
            // For local development, ApimanagementURL is expected to point to localhost (e.g. https://localhost:7088)
            // If testing through APIM locally, remove this override and use the APIM route instead
            landingPageUrl = `${appSettings.ApimanagementURL}/v2/payment/landingpage/${urlEncodedUniqueReference}/status`;
        }

        return this.get(landingPageUrl);
    }
}
